import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, SuccessButton } from "../..";
import {
  GREEN_LIGHT,
  WHITE,
  ORANGE_LIGHT,
  ORANGE,
  GREY,
  BLACK
} from "../../styles/shared/colors";
import "./BreakdownsBottomPanel.scss";

const BreakdownsBottomPanel = ({
  onFilterClick,
  onMakeClipClick,
  hasMakeClipButton,
  disableMakeClipButton,
  onClearFilters,
  hasClearFiltersButtons,
  disabledMessage
}) => {
  return (
    <div className="breakdowns-bottom-panel">
      {hasClearFiltersButtons && (
        <PrimaryButton
          showBorder
          color={GREY}
          background={BLACK}
          onClick={onClearFilters}
        >
          CLEAR FILTERS
        </PrimaryButton>
      )}
      <PrimaryButton
        background={GREEN_LIGHT}
        color={WHITE}
        onClick={onFilterClick}
      >
        FILTER
      </PrimaryButton>
      {hasMakeClipButton && (
        <div className="breakdowns-bottom-panel__make-clip">
          <div
            className="breakdowns-bottom-panel__make-clip__tooltip"
            style={{ display: disableMakeClipButton ? "block" : "none" }}
          >
            <span>{disabledMessage}</span>
          </div>
          <SuccessButton
            onClick={disableMakeClipButton ? null : onMakeClipClick}
            background={disableMakeClipButton ? ORANGE_LIGHT : ORANGE}
            style={{
              cursor: disableMakeClipButton && "default",
              filter: disableMakeClipButton && "brightness(1)"
            }}
          >
            MAKE CLIP
          </SuccessButton>
        </div>
      )}
    </div>
  );
};

BreakdownsBottomPanel.propTypes = {
  disabledMessage: PropTypes.string,
  disableMakeClipButton: PropTypes.bool, // eslint-disable-line
  hasClearFiltersButtons: PropTypes.bool,
  hasMakeClipButton: PropTypes.bool,
  onClearFilters: PropTypes.func,
  onFilterClick: PropTypes.func,
  onMakeClipClick: PropTypes.func
};

BreakdownsBottomPanel.defaultProps = {
  disabledMessage: "Please select events first",
  disableMakeClipButton: false,
  hasClearFiltersButtons: false,
  hasMakeClipButton: false,
  onClearFilters: () => {},
  onFilterClick: () => {},
  onMakeClipClick: () => {},
};

export default BreakdownsBottomPanel;
